<template>
  <div class="job_info_box">
    <div class="info_box">
      <div class="info_header">
        <div class="avatar_box">
          <img v-if="resume_info.avatar" :src="resume_info.avatar" alt="">
          <img v-else src="@/assets/img/company/detial/jianli/img1.png" alt="">
          <div class="sex_icon" :style="{background:resume_info.gender==1?'#4ba1f1':'#ff766f'}">
            <i class="el-icon-male" v-if="resume_info.gender==1"></i>
            <i class="el-icon-female" v-else></i>
          </div>
        </div>
        <div class="info_name_box">
          <div class="name">{{ resume_info.name }}</div>
          <div class="info_detial">
            <div class="info_item">{{ resume_info.age }}</div>
            <div class="info_item">{{ resume_info.experience }}</div>
            <div class="info_item">{{ resume_info.degree }}</div>
          </div>
          <div>
            <el-select style="width:148px;" v-model="resume_info.job_status" placeholder="请选择" @change="changeJobStatus">
              <el-option v-for="item in jobStatusOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="hope_job_box">
          <template v-if='resume_info.position.length!=0'>
            <div class="show_hope" v-for="(item,index) in resume_info.position.slice(0,1)" :key="index+'12'">期望：{{ item.name }}<span class="number" style="color: #FE574A;">{{ item.salary }}</span></div>
          </template>
          <div class="show_hope" v-else>期望：暂无期望职位</div>
          <template v-if='resume_info.education.length!=0'>
            <div class="show_hope" v-for="(item,index) in resume_info.education.slice(0,1)" :key="index">{{item.school_name}}·{{ item.major }}<span class="number">{{ item.time }}</span></div>
          </template>
          <div class="show_hope" v-else>暂无教育经历</div>
          <template v-if='resume_info.education.length!=0'>
            <div class="show_hope" v-for="(item,index) in resume_info.work_experience.slice(0,1)" :key="index">{{item.company_name}}·{{ item.position_name }}<span class="number">{{ item.time }}</span></div>
          </template>
          <div class="show_hope" v-else>暂无工作经历</div>
        </div>
        <div class="button_box" @click="goResume">
          在线简历 <i class="el-icon-caret-right"></i>
        </div>
      </div>
      <div class="info_tab">
        <div class="tab_item" :class="currentTab==item.id?'active':''" v-for="item in tabData" :key="item.id" @click="changeSelect(item.id)">
          <span class="name"> {{ item.name }}</span>{{ item.number }}
        </div>
      </div>
      <div class="info_content">
        <JobDetial :currentTab="currentTab" @changeNUmber="getMyInfo" />

      </div>

    </div>

  </div>
</template>

<script>
import JobDetial from "./JobDetial.vue";
export default {
  name: "",
  data() {
    return {
      tabData: [
        {
          name: "已投递",
          number: 4,
          id: 1,
          key: "apply_num",
        },
        {
          name: "面试",
          number: 4,
          id: 2,
          key: "interview_num",
        },
        {
          name: "已通过",
          number: 4,
          id: 3,
          key: "passed_num",
        },
        {
          name: "未通过",
          number: 4,
          id: 4,
          key: "failed_num",
        },
      ],
      currentTab: 1,
      resume_info: {
        id: null, //简历id
        name: "", //姓名
        avatar: "", //头像
        job_status: 1, //求职状态: 1=离职-随身到岗,2=在职-暂不考虑,3=在职-考虑机会,4=在职-月内到岗
        gender: 1, //性别: 1=男,2=女
        experience: "", //工作经验年限
        age: "", //年龄
        degree: "", //学历
        position: [], //期望职位
        education: [], //教育经历
        work_experience: [], //工作经历
      },
      jobStatusOption: [
        {
          label: "离职-随时到岗",
          value: 1,
        },
        {
          label: "在职-暂不考虑",
          value: 2,
        },
        {
          label: "在职-考虑机会",
          value: 3,
        },
        {
          label: "在职-月内到岗",
          value: 4,
        },
      ],
      currentData: [],
    };
  },
  components: {
    JobDetial,
  },
  mounted() {
    this.getMyInfo();
  },
  methods: {
    changeSelect(id) {
      this.currentTab = id;
    },
    getMyInfo() {
      this.$httpStudent.axiosGet(this.$api.resumeMyPosition, (res) => {
        if (res.code === 200) {
          Object.assign(this.resume_info, res.data.resume_info);
          this.tabData.forEach((item) => {
            item.number = res.data[item.key];
          });
          console.log(" this.tabData", this.tabData);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    goResume() {
      this.$router.push("/student/recruitmentCenter/personalResume");
    },
    changeJobStatus() {
      let params = {
        job_status: this.resume_info.job_status,
      };
      this.$httpStudent.axiosPost(
        this.$api.resumeSaveJobStatus,
        params,
        (res) => {
          if (res.code === 200) {
            this.$message.success("修改成功");
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    // 已投递的职位列表
  },
};
</script>
<style lang='scss' scoped>
.job_info_box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  box-sizing: border-box;
  .info_box {
    width: 1184px;
    .info_header {
      width: 100%;
      height: 141px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      display: flex;
      padding: 20px 24px;
      box-sizing: border-box;
      position: relative;
      .button_box {
        position: absolute;
        top: 20px;
        right: 0px;
        width: 98px;
        height: 36px;
        background: #f8f8f8;
        border-radius: 4px 0px 0px 4px;
        border: 1px solid #d4d5d6;
        border-right: 1px solid transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-weight: 400;
        font-size: 14px;
        color: #414a60;
      }
      .avatar_box {
        width: 60px;
        height: 60px;
        background: #d9d9d9;
        border-radius: 100%;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 100%;
        }
        .sex_icon {
          position: absolute;
          top: 0px;
          right: 0px;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          color: #fff;
          font-size: 12px;
          text-align: center;
          line-height: 14px;
        }
      }
      .info_name_box {
        margin-left: 20px;
        .name {
          font-weight: 400;
          font-size: 20px;
          color: #222222;
        }
        .info_detial {
          display: flex;
          margin: 12px 0;

          .info_item {
            margin-left: 15px;
            padding-right: 15px;
            position: relative;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            &:first-child {
              margin-left: 0;
            }
            &::before {
              content: "";
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 2px;
              height: 10px;
              background-color: #e5e5e5;
              border-radius: 4px;
            }
            &:last-child {
              &::before {
                display: none;
              }
            }
          }
        }
      }
      .hope_job_box {
        margin-left: 100px;
        .show_hope {
          margin-bottom: 17px;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          .number {
            margin-left: 18px;
            color: #999999;
          }
        }
      }
    }
    .info_tab {
      display: flex;
      align-items: center;
      height: 44px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      margin: 12px 0;
      .tab_item {
        margin-right: 40px;
        padding: 0 23px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        height: 100%;
        color: #b3b3b3;
        .name {
          height: 100%;
          display: flex;
          align-items: center;
          margin-right: 5px;
          color: #333333;
          cursor: pointer;
          border-bottom: 2px solid transparent;
        }
        &.active {
          color: #685ef5;
          .name {
            border-bottom: 2px solid #685ef5;
            color: #685ef5;
          }
        }
      }
    }
  }
}
</style>
